import { render, staticRenderFns } from "./NumberSpending.vue?vue&type=template&id=42ee6452&scoped=true&"
import script from "./NumberSpending.vue?vue&type=script&lang=js&"
export * from "./NumberSpending.vue?vue&type=script&lang=js&"
import style0 from "./NumberSpending.vue?vue&type=style&index=0&id=42ee6452&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ee6452",
  null
  
)

export default component.exports